export default {
  label: {
    shop: 'Shop',
    selectedShop: 'Shop',
    selectedBrand: 'Brand',
    selectedCategory: 'Category',
    SelectedFormat: 'Format',
  },
  page: {
    myShop: 'My Shop',
    screenText: 'Settings',
    searchPlaceholder: 'Please input shop name',
    viaText: 'Search via upload',
    clearBtnText: 'Reset',
    submitText: 'Submit',
    addToExport: 'Add to Download',
    rest: 'Clear',
    // next: 'Next',
    next: 'Confirm',
    noData: 'No Data',
    loading: 'Loading... ...',
    selectShopMsg: 'Please Select Shop(s)',
    selectFormatMsg: 'Please Select Report Format',
    selectCategoryMsg: 'Please select Category to Export',
    selectBrandMsg: 'Please select Brand(s)',
    fileSearchMsg: 'No Results Found',
  },
  selectShopFilter: {
    title: 'Filter',
  },
  exportFilter: {
    title: 'Filter',
    historyBtn: 'History Shops',
    skipBtn: 'Skip',
    confirmBtn: 'Confirm',
    fileNameInfo: 'Name your Download file…',
    fileNameRuleMsg: 'No special characters in the file name',
    selectShopMsg: 'Please Select Shop(s)',
    selectDateMsg: 'Please Time Frame',
    fileNameMsg: 'Please input file name',
    dateChangeMsg: 'Please choose the right time',
    selectGood: 'Please Select Shop(s)!',
    historyModal: {
      title: 'History Shops',
      no: 'No.',
      name: 'Name',
      date: 'Date',
      operation: 'Operation',
      choose: 'Choose',
      colse: 'Close',
    },
  },
};
